import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/sidebar_logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-a0dea7c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar navbar-vertical navbar-light fixed-start navbar-expand-md d-md-none",
  id: "sidebar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarCollapse",
  "aria-controls": "sidebarCollapse",
  "aria-expanded": "true",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "navbar-brand-img mx-auto",
  alt: "..."
}, null, -1))
const _hoisted_5 = { class: "navbar-user d-md-none" }
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = {
  href: "#",
  id: "sidebarIcon",
  class: "dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "avatar avatar-sm" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "fa-solid fa-user-circle text-muted",
  style: {"font-size":"40px"}
}
const _hoisted_11 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "sidebarIcon"
}
const _hoisted_12 = {
  class: "navbar-collapse collapse",
  id: "sidebarCollapse",
  style: {}
}
const _hoisted_13 = { class: "navbar-nav" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link" }, "Home")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Agenda")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Chat")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link" }, "Financeiro ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "nav-link text-paragraph" }, "Mais")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "navbar-brand text-start",
        to: _ctx.$paths.home
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.session?.profile_image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.session.profile_image,
                    class: "avatar-img rounded-circle",
                    alt: "..."
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("i", _hoisted_10))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
              class: "dropdown-item text-danger cursor-pointer"
            }, "Sair")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("ul", _hoisted_13, [
          _createVNode(_component_router_link, {
            "active-class": "router-link-active",
            to: _ctx.$paths.home
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            "active-class": "router-link-active",
            to: _ctx.$paths.appointments.list
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            "active-class": "router-link-active",
            to: _ctx.$paths.chat.list
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            class: _normalizeClass({ 'router-link-active': _ctx.financialLinkActive }),
            to: `${_ctx.$paths.financial.list}/repasses`
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["class", "to"]),
          _createVNode(_component_router_link, {
            to: `${_ctx.$paths.more}/minha-conta`,
            class: _normalizeClass({ 'router-link-active': _ctx.moreLinkActive })
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["to", "class"])
        ])
      ])
    ])
  ]))
}